// where the partner is in the authenticatorsTableData values array
export const partnerTableDataMap = {
  0: 'cgc',
  1: 'cgc',
  2: 'sgc',
  3: 'beckett',
  4: 'psa',
};

export const authenticatorsTableData = [
  {
    label: 'Cost Per Card',
    values: [
      ['$3'],
      ['$10'],
      ['$18'],
      ['$25'],
      ['From', '$79.99'],
    ]
  },
  {
    label: 'Numerical Grading',
    values: [
      ['No'],
      ['Yes'],
      ['Yes'],
      ['Yes'],
      ['Yes'],
    ]
  },
  {
    label: 'Subgrades Included',
    values: [
      ['No'],
      ['No'],
      ['No'],
      ['Yes'],
      ['No'],
    ]
  },
  {
    label: 'Condition Report',
    values: [
      ['No'],
      ['No'],
      ['No'],
      ['No'],
      ['No'],
    ]
  },
  {
    label: 'Factory Autograph Authentication',
    values: [
      ['Yes'],
      ['Yes'],
      ['Yes'],
      ['Yes'],
      ['Yes'],
    ]
  },
];

export const partnerIconSizes = {
  cgc: {
    height: '19px',
    width: '55px'
  },
  sgc: {
    height: '19px',
    width: '48px'
  },
  beckett: {
    height: '19px',
    width: '74px'
  },
  psa: {
    height: '19px',
    width: '50px'
  },
}
